<template>
  <div class="home">
    <div class="bt">
      <el-button type="text" size="samll">人气：{{ newsNum }}</el-button>
    </div>
    <el-dialog :visible="indexDialog" class="indexLogo" fullscreen :show-close="false" width="100%" style="height:100%">
      <div class="logo">
        <div class="image-logo" @click="btnLogo">
          <img ref="imgRef" :src="imgSrc" />
        </div>
        <div class="bounce" @click="btnLogo">
          <span class="letter">Click</span>
          <span class="letter">here</span>
          <span class="letter">点击</span>
          <span class="letter">进入</span>
        </div>
      </div>
    </el-dialog>

    <my-iframe @ready="ready" ref="iframeDom" frameborder="0" style="width: 100%; height: 100%" allow="xr-spatial-tracking; fullscreen"> </my-iframe>

    <!-- 底部按钮 -->
    <div class="bottomBtn">
      <!-- 播放 -->
      <div class="btn">
        <el-button :type="isPaly ? 'defalut' : 'warning'" :icon="isPaly ? 'el-icon-video-play' : 'el-icon-video-pause'" circle @click="onClickPalySwpeep"></el-button>
        <span>播放</span>
      </div>

      <!-- 导览 -->
      <div class="btn">
        <el-button :type="show2 ? 'warning' : 'defalut'" icon="el-icon-files" circle @click="show2 = !show2"></el-button>
        <span>导览</span>
      </div>

      <!-- 描述 -->
      <!-- <div class="btn">
        <el-button type="defalut" icon="el-icon-chat-dot-square" circle @click="headerDialog = true"></el-button>
        <span>描述</span>
      </div> -->

      <!-- 视角 -->
      <el-dropdown @command="moveTo" trigger="click">
        <div class="btn">
          <el-button type="defalut" icon="el-icon-coin" circle></el-button>
          <span>视角</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="dollhouse">鸟瞰视图</el-dropdown-item>
          <el-dropdown-item command="floorplan">俯瞰视图</el-dropdown-item>
          <el-dropdown-item command="inside">平行视图</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- 联系人 -->
      <div class="btn" v-if="showPhone">
        <el-button type="defalut" icon="el-icon-phone-outline" circle @click="headerPhoto = true"></el-button>
        <span>电话</span>
      </div>

      <!-- 背景音乐 -->
      <div class="btn">
        <el-button :type="bgMusicActive ? 'warning' : 'defalut'" icon="el-icon-headset" circle @click="clickBgMusic"></el-button>
        <span>音乐</span>
      </div>

      <!-- 场景音频 -->
      <div class="btn" v-if="isSweepMusic">
        <el-button :type="sweepMusicActive ? 'warning' : 'defalut'" icon="el-icon-headset" circle @click="clickSweepMusic"></el-button>
        <span>场景音乐</span>
      </div>
    </div>

    <!-- 缩略图 -->
    <transition name="el-zoom-in-bottom">
      <div v-show="show2" class="cover">
        <div>
          <swiper class="cover-swiper" :options="swiperOption" ref="mySwiper">
            <swiper-slide class="thumb-item" :class="activeIndex === index ? 'active' : ''" v-for="(item, index) in scenes" :key="index">
              <span v-show="item.name">{{ item.name }}</span>
              <img :src="item.thumbnailUrl" alt="" @click="onSwiperSlide(index)" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </transition>

    <!-- 标题文字的弹窗 -->
    <header-dialog v-if="resume && headerDialog" :data="resume" :headerDialog.sync="headerDialog" @clickBgMusic="clickBgMusic" />

    <!-- 视频文章的弹窗 -->
    <header-dialog v-if="video && videoDialog" :data="video" :headerDialog.sync="videoDialog" @clickBgMusic="clickBgMusic" @close="close" />

    <header-phone v-if="phone && headerPhoto" :data="phone" :headerPhoto.sync="headerPhoto" />

    <!--背景音频 控制窗口-->
    <audio ref="audio1" autoplay="autoplay" loop="loop" style="display:none"></audio>

    <!--场景音频 控制窗口-->
    <audio ref="audio2" autoplay="autoplay" style="display:none" @ended="overAudio2"  ></audio>

    <div v-show="audioBtn" style="position: fixed;left: 50%;transform: translateX(-50%);  top: 10px; z-index: 100000">
      <el-button :type=" audio3Active?  'warning' : 'deflut'" icon="el-icon-headset" circle  @click="onToggleAudio3"></el-button>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'

// 引入标题文本
import HeaderDialog from '@/components/headerDialog.vue'
import headerPhone from '@/components/headerPhone.vue'

import MyIframe from '@/views/Iframe.vue'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  name: 'Index',
  components: {
    HeaderDialog,
    headerPhone,
    MyIframe,
    swiper,
    swiperSlide
  },

  data() {
    return {
      audio3: null,
      audioBtn: false,
      audio3Active: false,
      show2: true,
      swiperOption: {
        spaceBetween: 5,
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        centeredSlides: false,
        freeMode: false,
        direction: 'horizontal'
      },
      sdk: {},

      // 主 背景音频
      oAudio1: null,
      isBgMusic: false,
      bgMusicActive: false,

      // 副 场景音频
      oAudio2: null,
      isSweepMusic: false,
      sweepMusicActive: false,
      temp_aictive: false,

      // 导览
      isPaly: true,
      playActive: false,

      // 视角
      angleActive: 1,

      active: 1,

      // 标题文本的对话框数据
      newsNum: null,

      linxiDialog: false,

      indexDialog: true,
      // --------右侧菜单栏状态 -----------/
      // 设置默认导览状态
      isGuidemap: false,

      // 设置默认全屏状态
      isScreenFull: false,

      initMusic: true,

      // --------底部菜单栏状态 -----------/
      // 设置标题对话框 显示和隐藏
      headerDialog: false,

      headerPhoto: false,

      videoDialog: false,

      video: null,

      // 设置 全景旋转  不旋转
      isEarthRotation: false,

      // --- 标签内容的点击状态 -------------------/
      // 设置标签对话框 显示和隐藏
      descDialog: false,

      windowWidth: 0,
      windowHeight: 0,
      sweeps: null,

      // 场景数据
      scenes: [],
      // 场景数据的长度
      thumbTotal: 0,
      activeIndex: 0
    }
  },
  created() {
    this.$nextTick(() => {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    })
    this.getNewsNum()
  },
  computed: {
    imgSrc() {
      if (this.windowWidth > this.windowHeight) {
        return this.$store.state.settings.thumbPC
      } else {
        return this.$store.state.settings.thumbMobile
      }
    },

    is_bgmusic() {
      return this.$store.state.settings.is_bgmusic
    },

    showPhone() {
      return this.$store.state.settings.showPhone
    },

    phone() {
      return this.$store.state.settings.phone
    },

    apiUrl() {
      return this.$store.state.settings.apiUrl
    },

    showResume() {
      return this.$store.state.settings.showResume
    },

    resume() {
      return this.$store.state.settings.resume
    },

    defaultMusic() {
      return this.$store.state.settings.defaultMusic
    },

    hotDatas() {
      return this.$store.state.settings.hotDatas
    },

    bgmusic() {
      return this.$store.state.settings.bgmusic
    },
    sweep_index() {
      return this.$store.state.settings.sweep_index
    }
  },
  mounted() {
    // 监听窗口大小改变
    window.onresize = () => {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    }
  },

  methods: {

    overAudio2() {
      this.sweepMusicActive = false
      console.log('播放完毕')
    },
    // 自加载
    async ready(sdk) {
      this.sdk = sdk
      const that = this

      that.sdk.Camera.zoomTo(0.8)

      sdk.Tour.getData()
        .then(_tour => {
          that.isPaly = true
        })
        .catch(function(_error) {
          that.isPaly = false
        })

      sdk.Sweep.data.subscribe({
        onCollectionUpdated: function(collection) {
          that.sweeps = Object.keys(collection)
        }
      })

      sdk.Tour.getData().then(r => {
        that.scenes = r
        that.scenes.map((e, i) => {
          e.index = i
        })
        that.thumbTotal = this.scenes.length
      })

      sdk.on(sdk.Mattertag.Event.HOVER, function(tagSid) {
        sdk.Mattertag.preventAction(tagSid, {
          opening: true,
          // 阻止热点缩进
          navigating: true
        })
      })

      sdk.on(sdk.Mattertag.Event.CLICK, function(tagSid) {
        sdk.Mattertag.preventAction(tagSid, {
          opening: true,
          // 阻止热点缩进
          navigating: true
        })
        that.temp_aictive = that.sweepMusicActive
        const item = that.hotDatas[tagSid]

        if (item && item.type === 'image') {
          // 背景音频
          const bgM = that.bgMusicActive
          // 场景音频
          const sweepM = that.sweepMusicActive

          that.audio3 = new Audio()
          viewerApi({
            options: {
              inline: true,
              // 遮罩层
              backdrop: true,
              // 关闭按钮
              button: 1,
              // 缩略图
              navbar: false,
              // 标题
              title: 0,
              // 操作按钮
              toolbar: false,
              // 双击还原
              toggleOnDblclick: true,
              // 缩放比例提示
              // tooltip: false,
              // 默认查看第2张
              // initialViewIndex: 2,
              // 是否可以拖拽
              movable: true,
              hide: function (e) {
                that.audioBtn = false
                that.audio3.pause()

                if (bgM) {
                  that.bgMusicActive = true
                }

                if (sweepM) {
                  that.sweepMusicActive = true
                }
              },
              viewed: function(e) {
                if (item.music) {
                  // 如果存在音频，就播放音频
                  that.audioBtn = true

                  that.audio3.src = item.music
                  that.audio3.play()
                  that.audio3Active = true

                  if (bgM) {
                    that.bgMusicActive = false
                  }

                  if (sweepM) {
                    that.sweepMusicActive = false
                  }
                }
              }
            },
            images: item.images
          })
        }
      })
    },

    onToggleAudio3() {
      if (this.audio3.paused) {
        this.audio3Active = true
        this.audio3.play()
      } else {
        this.audio3Active = false
        this.audio3.pause()
      }
    },

    onSwiperSlide(index) {
      this.sdk.Tour.stop()
      this.show2 = false
      this.isPaly = true
      this.sdk.Tour.step(index)
      this.activeIndex = index
    },

    extractHashFromURL(url) {
      const regex = /-(.+?)-/
      const match = url.match(regex)

      if (match && match[1]) {
        return match[1]
      } else {
        return null
      }
    },

    close() {
      this.sweepMusicActive = this.temp_aictive
      this.video = ''
      this.videoDialog = false
    },

    // 底部工具栏按钮事件-----------------------------------------------------

    onClickPalySwpeep() {
      if (this.isPaly) {
        this.sdk.Tour.start(this.activeIndex)
        this.isPaly = false
      } else {
        this.sdk.Tour.stop()
        this.isPaly = true
      }
    },

    // 音乐播放的事件
    clickBgMusic() {
      if (this.oAudio1.paused) {
        this.bgMusicActive = true
      } else {
        this.bgMusicActive = false
      }
    },

    clickSweepMusic() {
      if (this.oAudio2.paused) {
        this.sweepMusicActive = true
      } else {
        this.sweepMusicActive = false
      }
    },

    playAudio1() {
      this.oAudio1 = this.$refs.audio1
      const src = this.defaultMusic
      if (src) {
        this.oAudio1.src = src
        this.oAudio1.load()
        this.oAudio1.volume = 0.4
        this.isBgMusic = true
        this.bgMusicActive = true
      } else {
        this.isBgMusic = false
        this.bgMusicActive = false
      }
    },

    playAudio2() {
      this.oAudio2 = this.$refs.audio2
      const src = this.bgmusic[this.sweep_index]
      if (src) {
        this.oAudio2.src = src
        this.oAudio2.load()
        this.isSweepMusic = true
        this.sweepMusicActive = true
      } else {
        this.oAudio2.src = require('@/assets/kb.mp3')
        this.oAudio2.load()
        this.isSweepMusic = false
        this.sweepMusicActive = false
      }
    },

    moveTo(name) {
      console.log(name)
      switch (name) {
        case 'inside':
          this.active = 1
          this.sdk.Mode.moveTo('mode.inside')
          break
        case 'floorplan':
          this.active = 2
          this.sdk.Mode.moveTo('mode.floorplan')
          break

        case 'dollhouse':
          this.active = 3
          this.sdk.Mode.moveTo('mode.dollhouse')
          break
      }
    },

    //  封面按钮事件-----------------------------------------------------
    btnLogo() {
      this.playAudio1()
      this.playAudio2()
      this.indexDialog = false // 关闭弹出层
    },

    // 获取浏览量信息
    async getNewsNum() {
      const { data: res } = await this.$http.get(this.apiUrl)
      if (res.code === 200) {
        this.newsNum = res.data
      }
    }
  },
  watch: {
    sweep_index(_newValue) {
      console.log(_newValue)
      if (!this.indexDialog) {
        this.playAudio2()
      }
    },
    bgMusicActive(newValue) {
      if (this.oAudio1.paused && newValue) {
        this.oAudio1.play()
      } else {
        this.oAudio1.pause()
      }
    },

    sweepMusicActive(newValue) {
      if (this.oAudio2.paused && newValue) {
        this.oAudio2.play()
      } else {
        this.oAudio2.pause()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
}

.bottomRight {
  position: absolute;
  left: 50%;
  bottom: 90px;
  transform: translateX(-50%);

  a {
    list-style: none;
    text-decoration: none;

    .btn {
      background: orange;
      padding: 5px 30px;
      border-radius: 10px;
      color: #ffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        font-size: 14px;
        font-weight: bold;
      }

      .sub {
        font-size: 10px;
        margin-top: 5px;
      }
    }

    .img {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 40px;
      height: 40px;
      animation: scale 0.4s linear infinite;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@keyframes scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.6);
  }

  100% {
    transform: scale(1);
  }
}
</style>
